import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import FormSectionHeading from 'components/atoms/form/FormSectionHeading';
import EntityTreeSelectContainer from 'containers/EntityTreeSelectContainer';

const ParentEntities = props => (
    <React.Fragment>
        <FormSectionHeading>Parent Entities</FormSectionHeading>
        <Field name="parentEntityIds" key={props.entityId} component={EntityTreeSelectContainer} filterSelf filterChildren entityId={props.entityId} />
    </React.Fragment>
);

ParentEntities.propTypes = {
    entityId: PropTypes.number
};

export default ParentEntities;



// WEBPACK FOOTER //
// ./src/components/organisms/entity/edit/ParentEntities.js